module.exports = __webpack_public_path__ + "img/partner-forte.ad2f8e06.webp";